export default {"src":"/_next/static/media/external-link.0328a46c.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};